export default __webpack_public_path__ + "static/media/img_6.be2afdb6.jpg";